import { collection, getDocs, query, where } from "firebase/firestore";
import { db } from "../../firebaseConfig";

// Promedio y cantidad de reseñas SOLO de los artículos indicados (Firestore limita "in" a 10 valores).
export const obtenerResumenResenas = async (campoId, ids) => {
  const resumen = {};
  const unicos = [...new Set(ids)].filter(Boolean);
  for (let i = 0; i < unicos.length; i += 10) {
    const lote = unicos.slice(i, i + 10);
    const snap = await getDocs(query(collection(db, "resenas"), where(campoId, "in", lote)));
    snap.forEach((d) => {
      const r = d.data();
      const id = r[campoId];
      const acc = resumen[id] || (resumen[id] = { suma: 0, cantidad: 0 });
      acc.suma += Number(r.calificacion) || 0;
      acc.cantidad += 1;
    });
  }
  return resumen;
};
